import { SearchRankingResponse } from '../types/search';

// 환경 변수에서 API 기본 URL 가져오기
const getApiBaseUrl = () => {
  // 1. 환경 변수에서 직접 API URL 설정 가져오기
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // 2. 개발 서버 환경 감지 (delivereee.brainbackdoor.com)
  const isDevServer = typeof window !== 'undefined' && window.location.hostname.includes('brainbackdoor.com');
  
  // 3. 현재 URL 기반으로 프로덕션 여부 체크 (GitHub Pages 환경 감지)
  const isGitHubPages = typeof window !== 'undefined' && window.location.hostname.includes('github.io');
  
  // 4. NODE_ENV 환경 변수 확인
  const isProdEnv = process.env.NODE_ENV === 'production';
  
  // 개발 서버에서 실행 중이면 localhost:8080 사용
  if (isDevServer) {
    return 'http://localhost:8080';
  }
  
  // 프로덕션 또는 GitHub Pages에서 실행 중이면 운영 API URL 사용
  if (isProdEnv || isGitHubPages) {
    return 'https://api.brainbackdoor.com';
  }
  
  // 로컬 개발 환경에서는 로컬 URL 사용
  return 'http://localhost:8084';
};

const BASE_URL = getApiBaseUrl();

/**
 * 검색 랭킹을 가져오는 서비스
 */
export const getSearchRanking = async (): Promise<SearchRankingResponse> => {
  try {
    const response = await fetch(`${BASE_URL}/api/v1/search/ranking`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch search ranking:', error);
    throw error;
  }
};

/**
 * 로컬 스토리지에서 최근 검색어를 가져오는 함수
 */
export const getRecentSearches = (): string[] => {
  try {
    const stored = localStorage.getItem('recentSearches');
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Failed to get recent searches:', error);
    return [];
  }
};

/**
 * 최근 검색어를 로컬 스토리지에 저장하는 함수
 */
export const addRecentSearch = (keyword: string): void => {
  try {
    const current = getRecentSearches();
    const filtered = current.filter(item => item !== keyword);
    const updated = [keyword, ...filtered].slice(0, 10); // 최대 10개까지만 저장
    localStorage.setItem('recentSearches', JSON.stringify(updated));
  } catch (error) {
    console.error('Failed to save recent search:', error);
  }
};

/**
 * 최근 검색어를 모두 삭제하는 함수
 */
export const clearRecentSearches = (): void => {
  try {
    localStorage.removeItem('recentSearches');
  } catch (error) {
    console.error('Failed to clear recent searches:', error);
  }
};

/**
 * 특정 최근 검색어를 삭제하는 함수
 */
export const removeRecentSearch = (keyword: string): void => {
  try {
    const current = getRecentSearches();
    const filtered = current.filter(item => item !== keyword);
    localStorage.setItem('recentSearches', JSON.stringify(filtered));
  } catch (error) {
    console.error('Failed to remove recent search:', error);
  }
}; 